import React, { useContext } from "react";

import Button from "../button/Button";
import style from "./MultiChoiceBtnGroup.module.css";
import { observer } from "mobx-react-lite";

import { Grid } from "@mui/material";
import { RootStoreContext } from "../../store";

function MultiChoiceBtnGroup({ btnList }) {
  const { ExploreStore } = useContext(RootStoreContext);
  const { selectedObject1 } = ExploreStore;

  return (
    <Grid container style={{ width: "400px" }}>
      {btnList.map((text, index) => (
        <Grid item>
          <Button
            variant="h8"
            selected={selectedObject1.indexOf(text) !== -1}
            key={`${text}-${index}`}
            onClick={() => {
              if (selectedObject1.indexOf(text) !== -1) {
                var index = selectedObject1.indexOf(text);
                selectedObject1.splice(index, 1);
              } else {
                selectedObject1.push(text);
              }
            }}
            className={
              selectedObject1[text]
                ? style.ExploreGrayBtn
                : style.ExploreWhiteBtn
            }
          >
            {text}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
}

export default observer(MultiChoiceBtnGroup);
